import axios from './axios';

export default class LoanService {
  static createLoan(offer_public_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/create', { offer_public_id });
  }

  static getLoanData(agreement_id) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/agreement/loan/${agreement_id}`);
  }
 
  static signAgreement(offer_public_id, agreement_id, otp) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/loan/sign', { offer_public_id, agreement_id, otp });
  }

  static getOtpCode() {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/notification/sms/otp');
  }

  static getLoansList(params) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/list', params);
  }

  static getLoanById(id) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/loan/${id}`);
  }

  static loanPayment(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/loan/pay', payload);
  }
}